import {
  isURL,
  isSoundcloudURL,
  isVimeoURL,
  isYoutubeURL,
} from '@studionand/string-utils';

export const CLASSES_BY_SOURCETYPE = {
  unknown: 'URL',
  soundcloud: 'embed',
  vimeo: 'embed',
  yumpu: 'embed',
  youtube: 'embed',
};

export const GET_PROVIDER = url => {
  if (!isURL(url)) return 'unknown';
  if (isSoundcloudURL(url)) return 'soundcloud';
  if (isVimeoURL(url)) return 'vimeo';
  if (url.includes('yumpu')) return 'yumpu';
  if (isYoutubeURL(url)) return 'youtube';
  return 'unknown';
};

export function GET_YOUTUBE_ID(url) {
  let ID = '';
  const parsed = url
    .replace(/(>|<)/gi, '')
    .split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
  if (parsed[2] !== undefined) {
    ID = parsed[2].split(/[^0-9a-z_-]/i);
    ID = ID[0];
  } else {
    ID = parsed;
  }
  return ID;
}

export function GET_VIMEO_ID(url) {
  const splittedUrl = url.split('/');
  const id = splittedUrl[splittedUrl.length - 1];
  return id;
}
